/**
 * Create the store with asynchronously loaded reducers
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { fromJS } from 'immutable';
import { routerMiddleware } from 'react-router-redux';
import createSagaMiddleware from 'redux-saga';
import createReducer from './reducers';
import { connectSocket, socket } from './websockets';

import getBackendHost from 'getBackendHost';
import getFrontendHost from 'getFrontendHost';

import {
  unautorizedAccess,
  getOrganizationSaga,
  getUserSaga,
} from 'containers/App/sagas';

const sagaMiddleware = createSagaMiddleware();


export default function configureStore(initialState = {}, history) {

  const acaraDomains = process.env.ACARA_DEPLOY_ENV === 'production' ? [getFrontendHost(false, true), 'www.app.acara.io', 'app.acara.io'] : [getFrontendHost(false, true), 'staging.acara.io', 'www.staging.acara.io'];

  // Create the store with two middlewares
  // 1. sagaMiddleware: Makes redux-sagas work
  // 2. routerMiddleware: Syncs the location/URL path to the state


  const isAcara = acaraDomains.includes(window.location.hostname);

  const runSocket = isAcara ? socket(getBackendHost(true), { transports: ['websocket']}) : null;

  const middlewares = runSocket ? [
    sagaMiddleware,
    routerMiddleware(history),
    connectSocket(runSocket),
  ] : [
    sagaMiddleware,
    routerMiddleware(history)
  ];


  const enhancers = [
    applyMiddleware(...middlewares),
  ];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  /* eslint-enable */

  const store = createStore(
    createReducer(),
    fromJS(initialState),
    composeEnhancers(...enhancers)
  );


  sagaMiddleware.run(unautorizedAccess);
  sagaMiddleware.run(getOrganizationSaga);
  sagaMiddleware.run(getUserSaga);



  // Create hook for async sagas
  store.runSaga = sagaMiddleware.run;

  store.asyncReducers = {}; // Async reducer registry



  // Make reducers hot reloadable, see http://mxs.is/googmo
  /* istanbul ignore next */

  if (module.hot) {
    import('./reducers').then((reducerModule) => {
      const createReducers = reducerModule.default;
      const nextReducers = createReducers(store.asyncReducers);

      store.replaceReducer(nextReducers);
    });
  }

  return store;
}
